import create from 'zustand'
import {devtools} from 'zustand/middleware'

const useDragLineStore = create(devtools((set) => ({
  dragMode:false,
  setDragMode: (mode) => set((state) => ({dragMode: mode})),
  currentPt:null,
  addCurrentPt: (pt) => set((state) => ({currentPt: pt}))
})))

export default useDragLineStore